import React from "react";
import styled, { css } from "styled-components";

interface NewBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  count?: number;
}

const NewBadge = ({ count, ...rest }: NewBadgeProps) => {
  return <NewBadgeStyle {...rest}>{count ?? "N"}</NewBadgeStyle>;
};

export default NewBadge;

/* 스타일 */
const NewBadgeStyle = styled.div`
  background: #ff8642;
  border-radius: 10rem;

  display: flex;
  justify-content: center;
  align-items: center;

  ${({ theme }) => css`
    color: ${theme.color.text.white};
    font-weight: ${theme.fontWeight.bold};

    width: 1.8rem;
    height: 1.8rem;

    top: 0.9rem;
    right: -1.7rem;

    font-size: 1.1rem;
  `};
`;
